import React from "react";

import styles from "./Placeholder.module.css";

interface Props {
  text: string;
}

function Placeholder(props: Props) {
  const { text } = props;
  return (
    <div className={styles.container}>
      <div className={styles.icon}></div>
      <div className={styles.text}>{text}</div>
    </div>
  );
}

export default Placeholder;
